<div class="container d-flex justify-content-center align-items-center" style="height: 100vh;">
  <div class="w-50">
      <baxter-auth (successLogin)="successLogin($event)" [toastrService]="toastr" [application]="'ADMIN_DASHBOARD'"></baxter-auth>
  </div>
</div>
